import ProductsInfoCard from 'client/common/components/products-info-card/ProductsInfoCard';

import './ProductsInfoCard.css';

export default ProductsInfoCard;
